import { getPolicyNumber, guilt } from '../../../helpers/formData/collisionAbroadFormData';

export const getPolicyNumberProxy = field => getPolicyNumber()[field];
export const getGuiltValue = field => guilt[field];
